module.exports = __webpack_public_path__ + "static/media/soviet_infantry_div_120.81213782.png";